
window._ = require('lodash');

require('bootstrap');
global.$ = global.jQuery = require('jquery');

require('@selectize/selectize');
require('multiple-select');

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';

// loads the Icon plugin
UIkit.use(Icons);
